import type { PaginatedTransformedMaintenance } from "@/api/resources/maintenances/types";
import type { PaginatedMaintenanceStrategy } from "@/api/resources/maintenanceStrategies/types";
import type { PaginatedTransformedServiceJob } from "@/api/resources/serviceJobs/types";

export enum DailyOverviewViewType {
  Tasks = "tasks",
  Calendar = "calendar",
  Insights = "insights",
}

export type DailyOverviewCalendarEventPayload = {
  maintenance?: PaginatedTransformedMaintenance;
  strategy?: PaginatedMaintenanceStrategy;
  serviceJob?: PaginatedTransformedServiceJob;
};
